import { db } from '@/plugins/firebase';

export async function getPerformerDocByUserId(performerId) {
  const performerDocQuerySnapShot = await db
    .collection('performers')
    .doc(performerId)
    .get();
  const performerDoc = performerDocQuerySnapShot.data();
  if (!performerDoc) {
    return null;
  }
  performerDoc['id'] = performerId;
  return performerDoc;
}
